var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "multi-options-search-ui col-md-12" }, [
      !!_vm.assistMeConfig
        ? _c("div", { staticClass: "assist-me" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.assistMe,
                  expression: "assistMe",
                },
              ],
              staticStyle: { "vertical-align": "-10px" },
              attrs: {
                type: "checkbox",
                id: "assist_me",
                name: "assistMe",
                value: "assistMe",
              },
              domProps: {
                checked: Array.isArray(_vm.assistMe)
                  ? _vm._i(_vm.assistMe, "assistMe") > -1
                  : _vm.assistMe,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.assistMe,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "assistMe",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.assistMe = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.assistMe = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.assistMe = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "assist-me-label", attrs: { for: "assistMe" } },
              [_vm._v("Assist me!")]
            ),
          ])
        : _vm._e(),
      !_vm.assistMe
        ? _c("div", { staticClass: "search-ui-wrapper" }, [
            _c("div", { staticClass: "input parameter-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInputParameter,
                    expression: "userInputParameter",
                  },
                ],
                staticClass: "form-control multi-options-search-input",
                staticStyle: {
                  display: "inline-block",
                  height: "36px",
                  "margin-right": "15px",
                  "vertical-align": "middle",
                },
                attrs: {
                  name: "multi-options-search-input",
                  id: "search_param_context",
                  autoComplete: "off",
                },
                domProps: { value: _vm.userInputParameter },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.userInputParameter = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-right": "8px" },
                  attrs: { disabled: _vm.isLoading },
                  on: {
                    click: function ($event) {
                      return _vm.callSearch()
                    },
                  },
                },
                [_vm._v(" Search")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn-warning",
                  staticStyle: { display: "inline-block", height: "34px" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("Reset search")]
              ),
            ]),
          ])
        : _c("div", { staticClass: "search-ui-wrapper" }, [
            _c("div", { staticClass: "input parameter-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInputParameter,
                    expression: "userInputParameter",
                  },
                ],
                staticClass: "form-control multi-options-search-input",
                staticStyle: {
                  display: "inline-block",
                  height: "36px",
                  "margin-right": "15px",
                  "vertical-align": "middle",
                },
                attrs: {
                  name: "multi-options-search-input",
                  id: "search_param_context",
                  autoComplete: "off",
                },
                domProps: { value: _vm.userInputParameter },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.userInputParameter = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-right": "8px" },
                  attrs: { disabled: _vm.isLoading },
                  on: {
                    click: function ($event) {
                      return _vm.buildSearch()
                    },
                  },
                },
                [_vm._v(" Build search")]
              ),
            ]),
          ]),
    ]),
    !_vm.assistMe
      ? _c("div", { staticClass: "search-parameters-and-options" }, [
          _vm.searchOptions.kpGenes.length > 0
            ? _c("div", { staticClass: "kp-genes-options" }, [
                _c("div", [_vm._v("Genes")]),
                _c("div", { staticClass: "parameter-options" }, [
                  _c(
                    "div",
                    {
                      staticClass: "first-option option",
                      on: {
                        click: function ($event) {
                          return _vm.buildSearch({
                            label: _vm.searchOptions.kpGenes[0],
                            value: _vm.searchOptions.kpGenes[0],
                            parameter: "gene",
                          })
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.searchOptions.kpGenes[0]) + " ")]
                  ),
                  _vm.searchOptions.kpGenes.length > 1
                    ? _c(
                        "div",
                        { staticClass: "more-options" },
                        _vm._l(
                          _vm.searchOptions.kpGenes,
                          function (gene, geneIndex) {
                            return geneIndex > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "option",
                                    on: {
                                      click: function ($event) {
                                        return _vm.buildSearch({
                                          label: gene,
                                          value: gene,
                                          parameter: "gene",
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(gene) + " ")]
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm.searchOptions.kpPhenotypes.length > 0
            ? _c("div", { staticClass: "kp-phenotypes-options" }, [
                _c("div", [_vm._v("Phenotypes")]),
                _c("div", { staticClass: "parameter-options" }, [
                  _c(
                    "div",
                    {
                      staticClass: "first-option option",
                      on: {
                        click: function ($event) {
                          return _vm.buildSearch({
                            label:
                              _vm.searchOptions.kpPhenotypes[0].description,
                            value: _vm.searchOptions.kpPhenotypes[0].name,
                            parameter: "phenotype",
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.searchOptions.kpPhenotypes[0].description
                          ) +
                          _vm._s(
                            " (" + _vm.searchOptions.kpPhenotypes[0].group + ")"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm.searchOptions.kpPhenotypes.length > 1
                    ? _c(
                        "div",
                        { staticClass: "more-options" },
                        _vm._l(
                          _vm.searchOptions.kpPhenotypes,
                          function (phenotype, phenotypeIndex) {
                            return phenotypeIndex > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "option",
                                    on: {
                                      click: function ($event) {
                                        return _vm.buildSearch({
                                          label: phenotype.description,
                                          value: phenotype.name,
                                          parameter: "phenotype",
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(phenotype.description) + " "
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "other-options" },
            [
              _vm._l(_vm.searchCategories, function (parameter) {
                return [
                  _c("div", [_vm._v(_vm._s(parameter.label))]),
                  _c("div", { staticClass: "parameter-options" }, [
                    _c(
                      "div",
                      {
                        staticClass: "first-option option",
                        on: {
                          click: function ($event) {
                            return _vm.buildSearch({
                              label:
                                _vm.searchOptions.otherOptions[
                                  parameter.parameter
                                ][0].label,
                              value:
                                _vm.searchOptions.otherOptions[
                                  parameter.parameter
                                ][0].value,
                              parameter: parameter.parameter,
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.searchOptions.otherOptions[
                                parameter.parameter
                              ][0].label
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _vm.searchOptions.otherOptions[parameter.parameter].length >
                    1
                      ? _c(
                          "div",
                          { staticClass: "more-options" },
                          _vm._l(
                            _vm.searchOptions.otherOptions[parameter.parameter],
                            function (option, optionIndex) {
                              return optionIndex > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "option",
                                      on: {
                                        click: function ($event) {
                                          return _vm.buildSearch({
                                            label: option.label,
                                            value: option.value,
                                            parameter: parameter.parameter,
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(option.label) + " ")]
                                  )
                                : _vm._e()
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm.searchParamValues.length > 0
      ? _c("div", { staticClass: "search-plan-wrapper" }, [
          _c("h5", [
            _vm._v("Search plan: "),
            !!_vm.assistMe && !_vm.isEditing
              ? _c(
                  "span",
                  {
                    staticClass: "btn btn-sm edit-search-plan",
                    on: {
                      click: function ($event) {
                        return _vm.editSearchPlan()
                      },
                    },
                  },
                  [_vm._v(" Edit plan")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.assistMe && !!_vm.isEditing
              ? _c(
                  "span",
                  {
                    staticClass: "btn btn-sm edit-search-plan",
                    on: {
                      click: function ($event) {
                        return _vm.saveSearchPlan()
                      },
                    },
                  },
                  [_vm._v(" Save plan")]
                )
              : _vm._e(),
          ]),
          _vm.isEditing
            ? _c("div", [
                _c("input", {
                  staticClass: "form-control search-edit-input",
                  attrs: { type: "text", id: "search_value" },
                  domProps: { value: _vm.searchParamValues[0].label },
                }),
              ])
            : _vm._e(),
          _c(
            "div",
            _vm._l(_vm.sectionsConfig.sections, function (section, sIndex) {
              return section["data point"].parameters.includes(
                _vm.searchParamValues[0].parameter
              )
                ? _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(sIndex + 1 + ". ") +
                        "Search will query data for [ "
                    ),
                    _c("span", { staticClass: "search-key" }, [
                      _vm._v(_vm._s(section.header)),
                    ]),
                    _vm._v(" ] section with [ "),
                    _c("span", { staticClass: "search-key" }, [
                      _vm._v(_vm._s(_vm.searchParamValues[0].label)),
                    ]),
                    _vm._v(" ]. "),
                  ])
                : _vm._e()
            }),
            0
          ),
          !!_vm.focusValue
            ? _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _c("h5", [_vm._v("AI assited research focus: ")]),
                _vm.isEditing
                  ? _c("div", [
                      _c("input", {
                        staticClass: "form-control search-edit-input",
                        attrs: { type: "text", id: "focus_value" },
                        domProps: { value: _vm.focusValue.label },
                      }),
                    ])
                  : _vm._e(),
                _c("div", [
                  _vm._v("Extended search will focus on ["),
                  _c("span", { staticClass: "search-key" }, [
                    _vm._v(_vm._s(_vm.focusValue.label)),
                  ]),
                  _vm._v("]."),
                ]),
              ])
            : _vm._e(),
          !!_vm.assistMe && !_vm.isEditing && _vm.searchParamValues.length > 0
            ? _c(
                "div",
                {
                  staticStyle: { "margin-top": "15px", "text-align": "center" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "btn btn-primary",
                      staticStyle: { "margin-right": "8px" },
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        click: function ($event) {
                          return _vm.callSearch(_vm.focusValue)
                        },
                      },
                    },
                    [_vm._v(" Search")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "btn btn-warning",
                      staticStyle: { display: "inline-block", height: "34px" },
                      on: {
                        click: function ($event) {
                          return _vm.resetSearch()
                        },
                      },
                    },
                    [_vm._v("Reset search")]
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }